module.exports = __webpack_public_path__ + "media/customizations/lhermitage/logo-f7060f1e46015d5f66c1c0c463d6f92b.png";